import { Component } from "@angular/core"
import { ViewController, NavParams, AlertController, ModalController } from "ionic-angular"

import { EventDetailPage } from "./detail"

@Component({
  selector: "event-pick-list-page",
  templateUrl: "pick-list.html",
})
export class EventPickListPage {

  months = []
  options: any = {}

  constructor(
    private navParams: NavParams,
    private alertCtrl: AlertController,
    private viewCtrl: ViewController,
    private modalCtrl: ModalController
  ) {

    this.months = this.navParams.get("months")
    this.options = this.navParams.get("options")
  }

  pickOneOrMultiple() {

    return (this.options.pickOne || this.options.pickMultiple)
  }

  onCancel() {

    this.viewCtrl.dismiss()
  }

  onConfirm() {

    let selectedEvents = []

    this.months.forEach((month) => {

      month.events.forEach((event) => {

        if (event.selected)
          selectedEvents.push(event)
      })
    })

    if (selectedEvents.length > 0) {

      this.viewCtrl.dismiss(selectedEvents)

    } else {

      this.alertCtrl.create({
        message: "Nenhum evento selecionado",
        buttons: ["Ok"]
      }).present()
    }
  }

  onSelectAll() {

    this.months.forEach((month) => {

      month.events.forEach((event) => event.selected = true)
    })
  }

  onTapEvent(event) {

    if (!this.pickOneOrMultiple())
      return

    if (event.hasConflicts) {
      this.modalCtrl.create(EventDetailPage, { eventId: event._id, hideActionButtons: true }).present()
      return
    }

    event.selected = !event.selected

    if (this.options.pickOne) {

      this.months.forEach((month) => {

        month.events.forEach((el) => {

          if (el._id != event._id)
            el.selected = false
        })
      })
    }
  }

  onPressEvent(event) {

    const options = {
      eventId: event._id,
      hideConflictsMessage: !event.hasConflicts,
      hideActionButtons: true,
    }

    this.modalCtrl.create(EventDetailPage, options).present()
  }
}



// WEBPACK FOOTER //
// ./src/pages/events/pick-list.ts